export const componentsFormFileItemEn = {
  defaultImageTitle: 'Image',
  noFile: 'No file',
  unknownFileName: 'Unknown file name',
};
